<template lang="pug">
#pug
  router-view

//- <div id="app">
//- <router-view></router-view>
//- <debug-view v-if="showDebug"></debug-view>
//- <div class="test">test</div>
//- </div>
</template>

<script>
import {settings} from './config/config'
import DebugView from './utils/DebugView'
export default {
  data(){
    return{
      showDebug: settings.enableDebug
    }
  },
  components:{
    DebugView
  }

}
</script>
<style lang="sass">
.test
  position: absolute
  width: 100px
  height: 100px
  top: 0
  right: 0
  background: purple
</style>
